// import ModalForm from "./Form";
import PlacementBookingTableForm from "./PlacementBookingTableForm";
import {
	PLACEMENT,
	DATATABLE_EXPORT,
} from "../../../../../../../Config/ApiUrl";
import * as actions from "../../../../../../../Config/ApiUrl";
import { isNull } from "lodash";

export const PlacementBookingTableSchema = {
	components: { PlacementBookingTableForm },

	data() {
		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: "",
			Endpoint: PLACEMENT + "?clc_id_number=" + this.value.clc_id_number,
			tableId: "placement-booking-table",
			formId: "placement-booking-table-form",
			rowData: {},
			tableColumns: [
				{
					title: "Assigned Date",
					type: "text",
					key: "assigned_at",
				},
				{
					title: "Product Name",
					type: "custom-html",
					key: "product_id",
					modifier: (value) => {
						return value.name;
					},
				},
				{
					title: "Assigned By",
					type: "custom-html",
					key: "assigned_by",
					modifier: (value) => {
						return value.full_name;
					},
				},
				{
					title: "Booked Date",
					type: "text",
					key: "booked_date",
				},
				{
					title: "Booked Time",
					type: "custom-html",
					key: "booked_time",
					modifier: (value) => {
						return value.slice(0, -3);
					},
				},
				{
					title: "Completed By",
					type: "custom-html",
					key: "completed_by",
					modifier: (value) => {
						return isNull(value) ? "" : value.full_name;
					},
				},
				{
					title: "Sub Status",
					type: "custom-html",
					key: "sub_status",
					modifier: (value) => {
						if (value && value.status) {
							return `<span class="badge badge-sm badge-pill badge-${
								value.color_status ?? "primary"
							}">${this.$t(value.status)}</span>`;
						}
					},
				},
				{
					title: "Placement Date",
					type: "text",
					key: "placement_date",
				},
				{
					title: "Reference ID",
					type: "text",
					key: "reference_id",
				},
				{
					title: "Notes",
					type: "text",
					key: "notes",
				},
			],
			actionObj: {
				title: this.$t("action"),
				type: "action",
			},
			options: {
				name: "PlacementBookingTable",
				url: PLACEMENT + "?clc_id_number=" + this.value.clc_id_number,
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: true,
				columns: [],
				actions: [
					{
						title: this.$t("view"),
						icon: "eye",
						type: "custom-sub-tab",
						callbackId: (rowData) => this.checkCallbackId(rowData),
						disabled: (rowData) => {
							if (rowData.assign_schedules) {
								return rowData.assign_schedules?.invoice_id?.status !== "Paid";
							} else {
								return true;
							}
						}
					},
					{
						title: this.$t("edit"),
						icon: "edit",
						type: "none",
						// component: "app-add-modal",
						component: "placement-booking-table-form",
						modalId: "placement-booking-table-form",
						disabled: (rowData) => {
							if (rowData.assign_schedules) {
								return rowData.assign_schedules?.invoice_id?.status !== "Paid";
							} else {
								return true;
							}
						}
					},
					{
						title: "Confirm Schedule",
						icon: "check",
						type: "confirm-schedule",
						disabled: (rowData) => {
							if (rowData.assign_schedules) {
								return rowData.assign_schedules?.invoice_id?.status !== "";
							} else {
								return false;
							}
						}
					},
				],
				showFilter: true,
				showSearch: true,
				showCount: true,
				showClearFilter: true,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 3,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {
		checkCallbackId(rowData) {
			if (rowData.placement_type.id === 1) {
				return "class-trial";
			} else if (rowData.placement_type.id === 2) {
				return "placement-test";
			} else if (rowData.placement_type.id === 3) {
				return "direct-placement";
			} else {
				return "placement-booking";
			}
		},
	},
};
